import {Component, OnInit} from '@angular/core';
import {ReportsDataService} from './_services/reports-data.service';

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
    constructor(private reportsDataService: ReportsDataService) {
    }

    // Projects
    projectNumbers: number;
    archivedProjectNumbers: number;
    activeProjectNumbers: number;

    // Offers
    offersNumber: number;
    sentOffers: number;
    acceptedOffers: number;
    declinedOffers: number;

    // Companies
    allCompanies: number;

    // Jobs
    allJobs: number;
    activeJobs: number;

    // Candidates
    candidates: number;

    // Contracts
    allContracts: number;
    sendContracts: number;
    acceptedContracts: number;
    declinedContracts: number;
    archivedContracts: number;

    ngOnInit() {

        // Companies
        this.reportsDataService.getCompaniesNumber().subscribe((companies: any) => {
            this.allCompanies = companies.number;
        })

        // Projects
        this.reportsDataService.getAllProjectsNumber().subscribe((projects: any) => {
            this.projectNumbers = projects.number;
        })
        this.reportsDataService.getProjectByStatus('arhivat').subscribe((archivedProjects: any) => {
            this.archivedProjectNumbers = archivedProjects.number;
        })

        this.reportsDataService.getProjectByStatus('activ').subscribe((activeProjects: any) => {
            this.activeProjectNumbers = activeProjects.number;
        })

        // Offers
        this.reportsDataService.getOffersNumber().subscribe((offers: any) => {
            this.offersNumber = offers.number;
        })
        this.reportsDataService.getOffersByStatus('sent').subscribe((offers: any) => {
            this.sentOffers = offers.number;
        })
        this.reportsDataService.getOffersByStatus('accepted').subscribe((offers: any) => {
            this.acceptedOffers = offers.number;
        })
        this.reportsDataService.getOffersByStatus('declined').subscribe((offers: any) => {
            this.declinedOffers = offers.number;
        })

        // Jobs
        this.reportsDataService.getAllJobs().subscribe((jobs: any) => {
            this.allJobs = jobs.number;
        })
        this.reportsDataService.getAllActiveJobs().subscribe((jobs: any) => {
            this.activeJobs = jobs.number;
        })

        // Candidates
        this.reportsDataService.getCandidates().subscribe((candidates: any) => {
            this.candidates = candidates.number
        })

        // Contracts
        this.reportsDataService.getAllContracts().subscribe((contracts: any) => {
            this.allContracts = contracts.number;
        })
        this.reportsDataService.getContractsByStatus('sent').subscribe((contracts: any) => {
            this.sendContracts = contracts.number;
        })
        this.reportsDataService.getContractsByStatus('accepted').subscribe((contracts: any) => {
            this.acceptedContracts = contracts.number;
        })
        this.reportsDataService.getContractsByStatus('declined').subscribe((contracts: any) => {
            this.declinedContracts = contracts.number;
        })
        this.reportsDataService.getContractsByStatus('archived').subscribe((contracts: any) => {
            this.archivedContracts = contracts.number;
        })
    }
}
